import { ISetSelfServiceSubscriptionsFrequencyParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetSelfServiceSubscriptionsFrequencyRequest extends Request<ISetSelfServiceSubscriptionsFrequencyParams, IEmptyResult> {
    constructor(params: ISetSelfServiceSubscriptionsFrequencyParams) {
        super('setSubscriptionsSelfServiceSchedule', params);
    }
}
